import React from 'react';
import { Element } from 'react-scroll';
import { Submenu } from '../components';

export default (props) => (

  <div className="Content Identidade-Content">

  	<span className="Mob-Title"> <h3 className="red-txt"> Identidade </h3> </span>

    <h2> Essência, Valores e <br/> teoria de paradoxo </h2>

    <Submenu
      links={[
        { to: "a-essencia-em-dois-pilares", title: "A essência em <br/> dois pilares", offset: -200 },
        { to: "os-cinco-valores-brasal", title: "Os cinco <br/> valores Brasal", offset: -200 },
        { to: "os-seis-atributos-desejados", title: "Os seis atributos <br/> desejados", offset: -190 },
        { to: "teoria-de-paradoxo-brasal", title: "Teoria de <br/> Paradoxo Brasal", offset: -130 }
      ]} />

    <Element name="a-essencia-em-dois-pilares" className="Block">
    	<div className="Img-Wrapper Full">
    		<img src={require("../img/Identidade/essencia.jpg")}/>
    	</div>
    </Element>

    <Element name="os-cinco-valores-brasal" className="Block Center-Ie">
    	<div className="Text-Wrapper">
    		<h1 className="red-txt"> Os cinco <br/> valores brasal </h1>

    		<ul className="bold-txt">
  			  <li> <img src={require("../img/Identidade/pessoas.svg")}/> <div> <span> Pessoas </span><small> Sempre em primeiro lugar </small> </div> </li>
  			  <li> <img src={require("../img/Identidade/confianca.svg")}/> <div> <span> Confiança </span><small> A base dos relacionamentos que geram resultados sustentáveis </small> </div> </li>
  			  <li> <img src={require("../img/Identidade/excelencia.svg")}/> <div> <span> Excelência </span><small> Perserguição incansável da eficiência movida pela vontade de fazer mais e melhor </small> </div> </li>
  			  <li> <img src={require("../img/Identidade/evolucao.svg")}/> <div> <span> Evolução </span><small> Empreender, inovar, crescer e adaptar-se para ser cada vez mais relevante na vida das pessoas. </small> </div> </li>
  			  <li> <img src={require("../img/Identidade/marca.svg")}/> <div> <span> Marca </span><small> Acreditamos no valor da marca como garantia de credibilidade e reconhecimento </small> </div> </li>
  			</ul>

    	</div>
    </Element>

    <Element name="os-seis-atributos-desejados" className="Block Over-Block">

		<div className="bg-Overlap Center">
	   		<img src={require("../img/Identidade/atributos.jpg")}/>
	   	</div>

	    <div className="Overlap">
		    <div className="Text-Wrapper">
		    	<h1 className="red-txt"> Os seis atributos <br/> desejados </h1>
		    	<h2 className="red-txt"> Os seis atributos <br/> desejados </h2>

		    	<ul>
  				  <li> <div> <span> Crescimento / Evolução </span><small> Processos, investimentos e atitude em busca de crescimento estruturado e constante </small> </div> </li>
  				  <li> <div> <span> Proximidade </span><small> Ser mais relevante na vida dos clientes e ter um relacionamento cada vez mais estreito com colaboradores e parceiros. </small> </div> </li>
  				  <li> <div> <span> Contemporânea </span><small> Novos conceitos de gestão, novas ferramentas, novas tecnologias e um olhar sempre atual e moderno sobre o comportamento das pessoas e do mercado. </small> </div> </li>
  				  <li> <div> <span> Diversidade de Negócios </span><small> Continuar buscando a expanção em segmentos variados ou na verticalização dos segmentos de negócios atuais. </small> </div> </li>
  				  <li> <div> <span> Presença Nacional </span><small> Continuar buscando a ampliação dos territórios de atuação e novas parcerias para expansão dos negócios. </small> </div> </li>
  				</ul>

		    </div>
		</div>
    </Element>

    <Element name="teoria-de-paradoxo-brasal" className="Block Red-Block">
    	<div className="Text-Wrapper Content-Ajust white-txt">
    		<h1> Teoria de <br/> Paradoxo brasal </h1>

    		<div className="Teoria">
    			<small> LÓGICA COMUM </small>
    			<h3 className="white-txt"> Resultado <br/> Gera <br/> Confiança </h3>
    			<small> Você passa a confiar em marcas e pessoas depois de ver resultados comprovadamente positivos. </small>
    		</div>

    		<div className="Teoria">
    			<small> LÓGICA BRASAL </small>
    			<h3 className="white-txt"> Confiança <br/> Gera <br/> Resultado </h3>
    			<small> A confiança nas pessoas e nas relações gera uma energia volitiva capaz de produzir resultados positivos. </small>
    		</div>

    	</div>
    </Element>

  </div>

);



// WEBPACK FOOTER //
// ./src/pages/Identidade.js